import { DocumentIcon } from '@heroicons/react/24/outline';
import React from 'react';

/**
 * Empty state for preview pane when no components are present
 */
export const EmptyPreviewState: React.FC = () => {
  return (
    <div className="h-full flex items-center justify-center">
      <div className="text-center">
        <div className="flex h-16 w-16 items-center justify-center rounded-2xl bg-gray-50 border border-gray-200 mx-auto mb-4">
          <DocumentIcon className="h-8 w-8 text-gray-400" />
        </div>
        <h4 className="text-sm font-medium text-gray-900 mb-2">
          No Components Yet
        </h4>
        <p className="text-xs text-gray-500 max-w-xs">
          Start by adding components to your HIPAA package. They will appear
          here as you build your package.
        </p>
      </div>
    </div>
  );
};
